import { render, staticRenderFns } from "./ShipmentStats.vue?vue&type=template&id=3a2cbbd8&scoped=true"
import script from "./ShipmentStats.vue?vue&type=script&lang=js"
export * from "./ShipmentStats.vue?vue&type=script&lang=js"
import style0 from "./ShipmentStats.vue?vue&type=style&index=0&id=3a2cbbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2cbbd8",
  null
  
)

export default component.exports